<div id="configurationPrintTarget">
    <div class="isHidden printOnly">
        {{> spdcLogo }}
    </div>
    <div style="margin-bottom: 30px;">
        <div class="blocks blocks_spread">
            {{#if isTemplated}}
                <span class="lbl lbl_sm lbl_bold">[ {{productName}} ]</span>
            {{else}}
                <span class="lbl lbl_sm lbl_bold">[ {{productName}} ]</span>
                {{#if displayTotalPrice}}
                    <div class="lbl lbl_sm"><span class="lbl_bold">Price:</span>$ {{displayTotalPrice}}</div>
                {{/if}}
                {{#if quantity}}
                    <div class="lbl lbl_sm"><span class="lbl_bold">Quantity:</span> {{quantity}}</div>
                {{/if}}
            {{/if}}
            <a href="" class="link link_iconPrint js-action--printTrigger" data-print-target-id="configurationPrintTarget"><span class="isVisuallyHidden">Print</span></a>
        </div>
    </div>
    <div>
        <div class="isHidden printOnly printOnly_jobName">{{name}}</div>
        <div class="isHidden printOnly printOnly_jobDesc">{{description}}</div>
        <div class="hList hList_spread hList_alignRight">
            <a href="{{configureUrl}}" class="btn btn_reversed btn_fullWidth">Change Configuration</a>
        </div>
    </div>
    <div style="padding: 20px 40px; margin: 20px -40px -40px -40px; background-color: var(--c-OFFWHITE);">
        <table class="keyValTable keyValTable_40-60 keyValTable_ruleAbove">
            <tbody>
                {{#each configDetails.choices}}
                    <tr>
                        <th scope="row" class="lbl lbl_sm lbl_bold">{{key}}</td>
                        <td class="lbl lbl_serif lbl_lowercase">{{value}}</td>
                    </tr>
                {{/each}}
                {{#if configDetails.versions}}
                    <tr>
                        <th scope="row" class="lbl lbl_sm lbl_bold">Total Quantity</td>
                        <td class="lbl lbl_serif lbl_lowercase">{{quantity}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="lbl lbl_sm lbl_bold">Quantity by Version</td>
                        <td class="lbl lbl_serif lbl_lowercase">
                            {{#each configDetails.versions}}
                                <div>{{key}}: {{value}}</div>
                            {{/each}}
                        </td>
                    </tr>
                {{else}}
                    {{#if quantity}}
                        <tr>
                            <th scope="row" class="lbl lbl_sm lbl_bold">Total Quantity</td>
                            <td class="lbl lbl_serif lbl_lowercase">{{quantity}}</td>
                        </tr>
                    {{/if}}
                {{/if}}
                {{#each configDetails.additionalChoices}}
                    <tr>
                        <th scope="row" class="lbl lbl_sm lbl_bold">{{key}}</td>
                        <td class="lbl lbl_serif lbl_lowercase">{{value}}</td>
                    </tr>
                {{/each}}
            </tbody>
        </table>
    </div>
</div>
